import { useContext, useEffect, useState } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { AdminProtectedRoute, UnprotectedRoute } from "./routes";
import { Header, Footer, SideNavBar, NotFound } from "./components";
import {
  AddContent,
  AdminLoginScreen,
  Content,
  Dashboard,
  EditContent,
  Profile,
  Queries,
  User,
  ViewUser,
} from "./pages";
import jwt_decode from "jwt-decode";
import { useDispatch } from "react-redux";
import { logoutUser } from "./store";
import Lender from "./pages/lenders/Lender";
import ViewLender from "./pages/lenders/ViewLender";
import JobManagement from "./pages/jobs/Jobs";
import ViewJob from "./pages/jobs/ViewJob";
import ViewChat from "./pages/chat_section/ViewChat";
import Designation from "./pages/designation/Designation";
import AddDesignation from "./pages/designation/AddDesignation";
import Applicant from "./pages/applicant/Applicant";
import AddApplicant from "./pages/applicant/AddApplicant";
import TransactionManagement from "./pages/transactions/Transactions";
import ViewTransaction from "./pages/transactions/ViewTransaction";
import TandC from "./pages/public/TermsAndConditions";
import PP from "./pages/public/PrivacyPolicy";
import ContactUs from "./pages/public/ContactUs";
import DeleteAccount from "./pages/public/DeleteAccount";
import PropertyPreference from "./pages/property_prefernce/PropertyPreference";
import PropertyType from "./pages/property_prefernce/PropertyType";
import AppraiserPurpose from "./pages/appraiser_purpose/AppraiserPurpose";
import IntendedUser from "./pages/intended_users/IntendedUsers";
import PropertyOccupied from "./pages/property_occupied/PropertyOccupied";

function App() {
  const token = JSON.parse(localStorage.getItem("token"));

  const pageLocation = useLocation();
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [isExpanded, setExpandState] = useState(screenWidth > 768);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const logout = () => {
    logoutUser(dispatch);
    navigate("/");
  };

  const isTokenExpired = (token) => {
    if (!token) return true;

    try {
      const decoded = jwt_decode(token);
      const currentTime = Date.now() / 1000;
      // console.log(decoded);
      // console.log(currentTime);
      if (decoded.exp < currentTime) {
        return true;
      }
    } catch (error) {
      return true;
    }

    return false;
  };

  // useEffect(() => {
  //   if (isTokenExpired(token) && pageLocation.pathname !== "/terms-and-conditions" && pageLocation.pathname !== "/contact-us" && pageLocation.pathname !== "/privacy-policy" && pageLocation.pathname !== "/delete-account") {
  //     logout();
  //   }
  // }, [token, pageLocation]);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    setExpandState(screenWidth > 768);
  }, [screenWidth]);

  const sidebarHandler = () => setExpandState((prev) => !prev);

  const routeList = [
    { path: "/admin/dashboard", element: <Dashboard /> },
    { path: "/admin/view-profile", element: <Profile /> },

    // users
    { path: "/admin/users", element: <User /> },
    { path: "/admin/users/view/:id", element: <ViewUser /> },

    //lenders
    { path: "/admin/lenders", element: <Lender /> },
    { path: "/admin/lenders/view/:id", element: <ViewLender /> },

    //lenders
    { path: "/admin/jobs", element: <JobManagement /> },
    { path: "/admin/jobs/view/:id", element: <ViewJob /> },

    //Designation
    { path: "/admin/designation", element: <Designation /> },
    { path: "/admin/designation/add", element: <AddDesignation /> },

    //Applicant
    { path: "/admin/applicant", element: <Applicant /> },
    { path: "/admin/applicant/add", element: <AddApplicant /> },

    //Transactions
    { path: "/admin/transactions", element: <TransactionManagement /> },
    { path: "/admin/transaction/view/:id", element: <ViewTransaction /> },

    // static content
    { path: "/admin/content", element: <Content /> },
    { path: "/admin/content/create", element: <AddContent /> },
    { path: "/admin/content/update", element: <EditContent /> },

    // queries
    { path: "/admin/queries", element: <Queries /> },

    //chat
    { path: "/admin/chat/:id", element: <ViewChat /> },

    //  property preference 
    { path:"/admin/property_preference" , element:<PropertyPreference/>},

    //  property types 
    { path:'/admin/property_type' , element:<PropertyType/>},
    {path:'/admin/appraiser_purpose', element:<AppraiserPurpose/>},
    {path:'/admin/intended_user',element:<IntendedUser/>},
    {path:'/admin/property_occupied', element:<PropertyOccupied/>}
  ];

  return (
    <div className="main-wrapper">
      {/* Only show sidebar if token exists */}
      {isExpanded && token && (
        <div className="sidebar-overlay" onClick={sidebarHandler}></div>
      )}

      {/* Only show sidebar if user is logged in */}
      {token && (
        <div className="sidebar-wrapper">
          <SideNavBar isExpanded={isExpanded} />
        </div>
      )}

      <div
        className={`body-wrapper ${isExpanded ? "mini-body" : "full-body"} 
          ${token ? "" : "m-0"} d-flex flex-column`}
      >
        {/* Show header only for logged-in users */}
        {token && <Header sidebarHandler={sidebarHandler} />}

        <Routes location={pageLocation} key={pageLocation.pathname}>
          {/* Public Route: No Authentication Required */}
          <Route path="/terms-and-conditions" element={<TandC />} />
          <Route path="/privacy-policy" element={<PP />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/delete-account" element={<DeleteAccount />} />

          {/* Public Route: Admin Login Page */}
          <Route
            path="/"
            element={
              <UnprotectedRoute>
                <AdminLoginScreen />
              </UnprotectedRoute>
            }
          />

          {/* Private Routes: Require Authentication */}
          {routeList.map(({ path, element }) => (
            <Route
              key={path}
              path={path}
              element={<AdminProtectedRoute>{element}</AdminProtectedRoute>}
            />
          ))}

          {/* Catch-all Not Found Route */}
          <Route path="*" element={<NotFound />} />
        </Routes>

        {/* Show footer only for logged-in users */}
        {token && <Footer />}
      </div>
    </div>
  );
}

export default App;
